import { CardHeader, Label } from '@fluentui/react-components';
import * as React from 'react';
import { Stack, IStackStyles, IStackTokens, IStackItemStyles } from '@fluentui/react/lib/Stack';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import './LargeUpload.css';
import { IInputs } from './generated/ManifestTypes';
import { Link, Text } from '@fluentui/react';
export interface ILargeUploadProps {
    accessToken: string;
    sharepointDriveId: string;
    sharepointFolderId: string;
    title?: string; // Optional title prop
    ref?: React.RefObject<LargeUpload>;
    notifyOutputChanged?: () => void;
}

type UploadStatus = 'selection' | 'uploading' | 'complete' | 'failed' | 'cancelled';

interface ILargeUploadState {
    percentComplete: number;
    status: UploadStatus;
    chosenFileName: string;
    newFileName: string;
    
    createSessionResponse: string;
    uploadURL: string;
    lastResponseCode: number;
    nextExpectedRangedResponse: string;
    chunksRead: number;
    fileSize: number;
    errorMessage: string;
    sharepointFileId: string;
    sharepointFileUrl: string;
    fileSelected: boolean;
}

export class LargeUpload extends React.Component<ILargeUploadProps, ILargeUploadState> {
    private fileInputRef = React.createRef<HTMLInputElement>();

   
    //TODO: add site url as pros and also doc library name..see what sharepoint actions do

    //TODO: Add comments and doco, and create comp library package

    constructor(props: ILargeUploadProps) {
        super(props);
        this.state = {
            percentComplete: 0,
            status: 'selection',
            chosenFileName:"",
            newFileName: "",
            createSessionResponse: "",
            uploadURL: "",
            lastResponseCode: 0,
            nextExpectedRangedResponse: "",
            chunksRead: 0,
            fileSize: 0,
            errorMessage: "",
            sharepointFileId: "",
            sharepointFileUrl: "",
            fileSelected:false
        };
        this.onUploadClicked = this.onUploadClicked.bind(this);
        this.onCancelClicked = this.onCancelClicked.bind(this);
        this.onRestartClicked = this.onRestartClicked.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.onFileInputChanged = this.onFileInputChanged.bind(this);
    }

    // Expose newFileName as an output property
    public get sharepointFilename(): string {
        return this.state.newFileName;
    }


    resetForm() {
        this.setState({
            percentComplete: 0,
            status: 'selection',
            newFileName: "",
            chosenFileName: "",
            createSessionResponse: "",
            uploadURL: "",
            lastResponseCode: 0,
            nextExpectedRangedResponse: "",     
            chunksRead: 0, fileSize: 0,
            errorMessage: "",
            sharepointFileId: "",
            sharepointFileUrl: "",
            fileSelected:false
        });
    }
    private delay(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async onUploadClicked(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        console.log('Upload button clicked');


        const fileInput = this.fileInputRef.current;
        const myFile = fileInput?.files?.[0];
        if (myFile) {
            this.setState({ status: 'uploading' });

            // 3 second delay here
                    await this.delay(3000);
                    await this.CreateUploadSession();
                    const size: number = myFile.size;
                    const chunkSize = 60 * 327680; // 30 * 320KB chunks
            this.setState({ fileSize: size, chunksRead: 0 }, () => {
                            this.readChunk(myFile, size, 0, chunkSize);
            });
           
                }
        else {
            alert("Please select a file to upload.");
        }
      
    };


    

    onCancelClicked() {
        this.SendCancelSession();
        this.resetForm();
        this.setState({ status: 'cancelled' }, () => { 
        if (this.props.notifyOutputChanged) {
            this.props.notifyOutputChanged();
        }   
    });
    }

    onRestartClicked() {
        this.resetForm();
        this.setState({ status: 'selection' }, () => {
            if (this.props.notifyOutputChanged) {
                this.props.notifyOutputChanged();
            }
        });
    }

    onFileInputChanged(event: React.ChangeEvent<HTMLInputElement>) {
        const file = event.target.files?.[0];
        if (file) {
            this.setState({ chosenFileName: file.name, newFileName: file.name, fileSelected: true }, () => {
                if (this.props.notifyOutputChanged) {
                    this.props.notifyOutputChanged();
                }
            });
        }
    }




    PercentCompleteCalc(size: number, offset: number) {
        this.setState({ percentComplete: Math.min(100, Math.floor((offset / size) * 100)) });

    }
    BuildCreateSessionBody(): object {

        var body = {
            item: {
                "@microsoft.graph.conflictBehavior": "fail",
                name: this.state.newFileName
            }
        };
        return body;
        
    }


    BuildCreateSessionURL() :string {
      var  url: string ="https://graph.microsoft.com/v1.0/drives/" +
                    this.props.sharepointDriveId + // <-- Use props here
                    "/items/" +
                    this.props.sharepointFolderId +
                    ":/" +
                    this.state.newFileName +
                    ":/createUploadSession"
           
      
        console.log("Create Session URL: " + url);

        return url;

    }

    async SendCancelSession() {

        await fetch(this.state.uploadURL, {
            method: "DELETE",
            headers: {
               
            },
            body: ""
        })
    }



    async SendSlice(blobdata: ArrayBuffer, offset: number, endPoint: number, size: number) {
    // Example: Log the blob size, you can replace this with your upload logic
        console.log('Sending slice of size:', blobdata ? blobdata.byteLength : 0);
        //console.log('Sending slice of size stringified:', blobdata ? blobdata.toString().length : 0);
        console.log("Content range calc: :", `bytes ${offset}-${endPoint - 1}/${size}`);
       
        
    // You can add code here to send the blob to a server or process it further
        await fetch(this.state.uploadURL, {
        method: "PUT",
        headers: {
            "Content-Length": blobdata.byteLength.toString(), //size of current request
            "Content-Range": `bytes ${offset}-${endPoint - 1}/${size}` //range of bites within the whole file
        },
        body: blobdata
    })
        .then(response => {
            this.setState({ lastResponseCode: response.status });
          
          
            if (response.status === 201 || response.status === 200) { // Upload complete
                response.json().then(data => {
                    this.setState({
                        nextExpectedRangedResponse: data.nextExpectedRanges,
                        sharepointFileId: data.id,
                        sharepointFileUrl: data.webUrl
                    }, () => {
                        // Safe to use this.state here
                        if (this.props.notifyOutputChanged) {
                            this.props.notifyOutputChanged();
                        }
                        console.log("Chunk upload response code:", response.status);
                        console.log("NextExpectedRanges:", data.nextExpectedRanges);

                        console.log("Uploaded Document ID:", data.id);
                        console.log("Uploaded Document URL:", data.webUrl);
                    });
                   

                   
                });
            }

            // You can add more logic here to handle the response
        })
        .catch(error => {
            console.error("Error uploading chunk:", error);
            this.setState({ lastResponseCode: error.status , errorMessage: error.message , status: 'failed' });
        });
}



 async CreateUploadSession() {
     try {
         const response = await fetch(this.BuildCreateSessionURL(), {
             method: "POST",
             headers: {
                 "Content-Type": "application/json",
                 // You may need to add Authorization header here if required:
                 "Authorization": this.props.accessToken
             },
             body: JSON.stringify(this.BuildCreateSessionBody())

         });
         if (!response.ok) {
             // Handle non-2xx HTTP responses
             const errorText = await response.text();
             throw new Error(`HTTP ${response.status}: ${errorText}`);
         }
         const data = await response.json();
         console.log("Upload session response:", data);
         this.setState({
             createSessionResponse: data,
             uploadURL: data.uploadUrl,
             nextExpectedRangedResponse: data.nextExpectedRanges
         });
         console.log("Upload URL:", data.uploadUrl);
         console.log("NextExpectedRanges:", data.nextExpectedRanges);

         // You can add more logic here to handle the response
     } catch (error) { 
        console.error("Unhandled Error creating upload session:", error);
        this.setState({ errorMessage: (error as Error).message, status: 'failed' });
    }
}


    private async readChunk(
        myFile: File,
        size: number,
        offset: number,
        chunkSize: number
    ): Promise<void> {
        if (this.state.status === 'cancelled') {
            return;
        }
        if (this.state.status === 'failed') {
            return;
        }
        if (offset >= size) {        
            this.setState({ status: 'complete' });          
            return;
        }
        const endPoint = Math.min(offset + chunkSize, size);
        const blob = myFile.slice(offset, endPoint);
        const reader = new FileReader();
        reader.onloadend = async (event) => {
            const result = (event.target as FileReader).result;
            if (result) {
                await this.SendSlice(result as ArrayBuffer, offset, endPoint, size);
                this.setState(prevState => ({
                    chunksRead: prevState.chunksRead + 1
                }));
                this.PercentCompleteCalc(size, endPoint);
                this.readChunk(myFile, size, endPoint, chunkSize);
            }
        };
        reader.readAsArrayBuffer(blob);
    }

    componentDidUpdate(prevProps: ILargeUploadProps) {
        if (prevProps.accessToken !== this.props.accessToken) {
            
        }
    }

    public render(): React.ReactNode {
        const { title = "File upload" } = this.props; // Default to 'File upload' if not set
        return (
            <div id="largeUploadControl">
                <form>
                    {this.state.status === 'selection' && (
                        <div id="form">
                            <Stack
                                
                                styles={{ root: { padding: '10px', maxWidth: 600, margin: '0 auto' } }}
                                tokens={{ childrenGap: 15 }}
                            >
                                
                                <Stack.Item grow>
                                    <h2>{title}</h2>
                                </Stack.Item>
                              
                                {/* Left Column */}
                                <Stack.Item grow>
                                    <Stack tokens={{ childrenGap: 10 }}>
                                        
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
                                            <label htmlFor="fileInput">Select a source file:</label>
                                            <input
                                                type="file"
                                                id="fileInput"
                                                ref={this.fileInputRef}
                                                name="fileInput"
                                                accept=".zip"
                                                onChange={this.onFileInputChanged}
                                                
                                            />
                                        </div>
                                    </Stack>
                                </Stack.Item>
                               
                                <Stack.Item grow>
                                   
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            <label htmlFor="targetSharepointDoc" >Destination file name:</label>
                                            <input
                                                type="text"
                                                id="targetSharepointDoc"
                                                style={{ width: '100%' }}
                                                value={this.state.newFileName}
                                                onChange={e => this.setState({ newFileName: e.target.value }, () => {
                                                    if (this.props.notifyOutputChanged) {
                                                        this.props.notifyOutputChanged();
                                                    }
                                                })}
                                            />
                                        </div>
                                        <button 
                                            type="button"
                                            id="uploadButton"
                                        onClick={this.onUploadClicked}
                                        disabled={!this.state.fileSelected} 
                                            style={{ marginTop: 16, width: '100%' }}
                                        ><b>Upload file</b>
                                        </button>
                                  
                                </Stack.Item>
                            </Stack>
                        </div>
                    )}
                    {this.state.status === 'uploading' && (
                        <div id="progressInfo">
                            <Label>Progress {this.state.percentComplete}%</Label>
                            <Spinner size={SpinnerSize.large} />
                            <span><pre id="fileSize">File size:{this.state.fileSize} bytes</pre>
                                <pre id="chunksRead">{this.state.chunksRead} chunks sent</pre>
                               
                                <button type="button" id="cancelButton" onClick={this.onCancelClicked}>Cancel</button>
                            </span>
                        </div>
                    )}
                    {this.state.status === 'failed' && (
                        <div id="errorInfo">
                            <h2> An error occurred</h2>
                            <div id="errMsg">{this.state.errorMessage}</div>
                            <span><span></span><br></br>
                                <button type="button" id="restartButton" onClick={this.onRestartClicked}>Restart</button>
                            </span>
                        </div>
                    )}
                    {this.state.status === 'complete' && (
                        <div id="successInfo">
                            <h2> File Uploaded</h2>
                            <div id="newName">File {this.state.chosenFileName} has been uploaded to sharepoint as '{this.state.newFileName}'</div>
                            <div id="docId">The sharepoint file id : {this.state.sharepointFileId}</div>
                            <div id="docURL">The sharepoint URL : <Link href={this.state.sharepointFileUrl} underline>{this.state.sharepointFileUrl}</Link> </div>

                            <button type="button" id="restartButton2" onClick={this.onRestartClicked}>Upload another file...</button>
                        </div>
                    )}
                    {this.state.status === 'cancelled' && (
                        <div id="cancelledInfo">
                            <h2> File cancelled</h2>
                           
                            <button type="button" id="restartButton3" onClick={this.onRestartClicked}>Upload another file...</button>
                        </div>
                    )}
                </form>
            </div>
        );
    }
}

